import type { ArticleIconInfo } from '~/common/types/articleIconInfo';
import { cn } from '~/common/utils/styleUtil';
import { Tooltip, TooltipContent, TooltipTrigger } from '~/common/components/ui/tooltip';

export function ArticleIcons({
  icons,
  className,
  reserveSpace = true
}: Readonly<{ icons: ArticleIconInfo[]; className?: string; reserveSpace?: boolean }>) {
  return (
    <div className={cn('flex gap-0.5', reserveSpace && 'h-8', className)}>
      {icons.map(icon => (
        <Tooltip key={icon.id}>
          <TooltipTrigger asChild>
            <img
              src={icon.imgSrc}
              alt={icon.title}
              className={'mr-1 h-fit'}
              width="48px"
              height="48px"
              data-testid={`article-icon-${icon.id}`}
            />
          </TooltipTrigger>
          <TooltipContent>{icon.title}</TooltipContent>
        </Tooltip>
      ))}
    </div>
  );
}
